<template>
  <div id="app">
    <Header v-if="!isShow" :isColor="newPath"></Header>
    <router-view />
    <Footer v-if="$route.meta.isFooter"></Footer>

    <div>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="visibleDialog"
        width="30%"
        :before-close="handleClose"
        v-if="visibleDialog"
      >
        <div>
          <!-- 注册 -->
          <Register v-if="isLoginOrRegister == 2"></Register>
          <!-- 忘记密码 -->
          <ForgotPassword v-else-if="isLoginOrRegister == 3"></ForgotPassword>
          <!-- 登录 -->
          <Login v-else></Login>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Login from "@/views/LoginRegister/LoginPage/index.vue";
import Register from "@/views/LoginRegister/Enroll/index.vue";
import ForgotPassword from "@/views/LoginRegister/ForgotPassword/index.vue";
import Header from "@/components/Home/header";
import Footer from "@/components/Home/footer";
import store from "./store";
export default {
  data() {
    return {
      isShow: false,
      newPath: null,
    };
  },
  components: {
    Header,
    Footer,
    Login,
    Register,
    ForgotPassword,
  },
  methods: {
    handleClose(done) {
      this.$store.commit("HANLE_VISIBLE_DIALOG", false);
    },
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.isShow = this.$route.meta.isHeader;
    },
  },
  computed: {
    isLoginOrRegister() {
      return this.$store.state.User.isLoginOrRegister;
    },
    visibleDialog() {
      return this.$store.state.User.visibleDialog;
    },
  },
  mounted() {},
};
</script>
  
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}
.header-title {
  color: #f96a26;
  font-size: 22px;
  margin-bottom: 20px;
}
.el-pagination {
  margin: 30px 0;
  text-align: center;
}
.el-dialog {
  border-radius: 12px !important;
  .el-dialog__header {
    padding: 20px 0 0 0;
  }
}
// 媒体查询大于等于1920
@media screen and (min-width: 1920px) {
  .el-image-viewer__prev {
    left: 320px !important;
  }
  .el-image-viewer__next {
    right: 320px !important;
  }
}
</style>
